import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { HashRouter, Redirect } from 'react-router-dom';
import Stopper from '../Stopper/Stopper';
import { actions as errorActions } from '../../../reducers/error';
import { actions as usersAction } from '../../../reducers/users';
import { actions as myRouterActions } from '../../../reducers/myRouter';
import Routes from './Routes/Routes';
import { getUrl, URL } from '../../../utils/urlLibrary';

import './MainContent.scss';
import { goToLogin, logInNeeded } from '../../../sagas/normalizers/errorNormalizer';
import { getDefaultLibFileName } from 'typescript';
import { hasStoredAuthSession } from '../../../utils/logoutFlow';

/** * Stateful component to draw MainContent.
 * @returns {JSX} Component MainContent JSX.
 */
/*
export const previousLocation = [];
*/
class MainContent extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
    };
  }

  componentDidMount = () => {
    // Aquí irían las llamadas principales de nuestra aplicación
    // las que queremos que se hagan nada más arrancar
    const { setUserToken, setUserRol, getAuthenticated } = this.props;
    const userToken = localStorage.getItem('token');
    const userRol = localStorage.getItem('currentUserRol');
    if (userToken) {
      setUserToken(userToken);
      if (userRol) setUserRol(userRol);
      getAuthenticated();
    }
  };

  static getDerivedStateFromProps(props, state) {
    const { currentLocation, makeLogoutDone, handlingCode, authenticatedError, setUserRol, setUserToken, makeLogoutStatus, userToken, userRol, resetUser, makeLogoutStatusError } = props;

    if((!userToken || !userRol)
      && (currentLocation !== URL.home.hash && currentLocation !== URL.register.hash && currentLocation !== URL[404].hash)
      && (currentLocation !== URL.sessionExpired.hash)) {
      const userToken = localStorage.getItem('token');
      const userRol = localStorage.getItem('currentUserRol');
      console.log(currentLocation)
      if (!userToken || !userRol) {
        resetUser();
        if (makeLogoutDone) {
          goToLogin();
        } else {
          logInNeeded();
        }
      }
    }

    if (currentLocation !== state.currentLocation) {
      const lastLocation = props.previousLocation;
      props.setPreviousLocation(currentLocation);
      props.clearError();
      if((authenticatedError || makeLogoutStatus) && currentLocation !== URL.sessionExpired.hash && !makeLogoutStatus) {
        props.getAuthenticated()
      }
      return {
        ...state,
        handlingCode: 0,
        previousLocation: lastLocation,
        currentLocation,
      };
    }

    return {
      ...state,
      handlingCode,
    };
  }

  render() {
    const { history, clearError, currentLocation, userToken, userRol } = this.props;
    const { handlingCode } = this.state;
    const normalizedCurrentLocation = currentLocation || URL.home.hash;
    const publicRoutes = [URL.home.hash, URL.register.hash, URL[404].hash, URL.sessionExpired.hash];
    const hasAuthSession = (!!userToken && !!userRol) || hasStoredAuthSession();
    const isProtectedRoute = !publicRoutes.includes(normalizedCurrentLocation);

    if (!hasAuthSession && isProtectedRoute) {
      return (
        <Fragment>
          <HashRouter>
            <Redirect to={getUrl('home')} />
          </HashRouter>
        </Fragment>
      );
    }

    return (
      <Fragment>
        <HashRouter>
          <div id="mainContent" className="mainContent">
            {/* Aquí podría ir una modal de bienvenida por ejemplo */}
            {handlingCode < 0 && (
              <Stopper
                handlingCode={handlingCode}
                clearError={clearError}
              />
            )}
            {handlingCode >= 0 && (
              <Routes
                history={history}
              />
            )}
          </div>
          {currentLocation !== '/404' && (
            <div className="NavBar bottom navBarHeight" />
          )}
          {/* <Modal projectId={PROJECT_ID} /> */}
        </HashRouter>
      </Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearError: () => dispatch(errorActions.clearError()),
    setPreviousLocation: location => dispatch(myRouterActions.setPreviousLocation(location)),
    setUserToken: userToken => dispatch(usersAction.setUserToken(userToken)),
    setUserRol: userRol => dispatch(usersAction.setUserRol(userRol)),
    resetUser: () => dispatch(usersAction.resetUser()),
    getAuthenticated: () => dispatch(usersAction.getAuthenticated()),
  };
};

const mapStateToProps = state => ({
  userToken: state.users.userToken,
  userRol: state.users.userRol,
  makeLogoutStatus: state.users.makeLogoutStatus,
  makeLogoutStatusError: state.users.makeLogoutStatusError,
  handlingCode: state.error.handlingCode,
  currentLocation: state.router.location.pathname,
  previousLocation: state.myRouter.previousLocation,
  authenticatedError: state.users.authenticatedError,
  makeLogoutDone: state.users.makeLogoutDone,
});

export default connect(mapStateToProps, mapDispatchToProps)(MainContent);
